import React from 'react';
import Navigation from '../components/Navigation';
import Pokemon from '../components/Pokemon';
import Logo from '../components/Logo';
import Footer from '../components/Footer';

const Home = () => {
    return (
        <div>
            <Logo/>
            <Navigation />
            <Pokemon />
            <Footer />
        </div>
    );
};

export default Home;